import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { BookingDialog } from "@/components/BookingDialogLazy";
import { SEOHead } from "@/components/SEOHead";
import { BreadcrumbSchema } from "@/components/StructuredData";
import { Calendar, CheckCircle2, Clock, MessageSquare } from "lucide-react";
import { trackPhoneClick } from "@/lib/analytics";

const Termin = () => {
  const [showBooking, setShowBooking] = useState(true);

  return (
    <>
      <SEOHead
        title="Termin buchen - Kostenloses Beratungsgespräch | Clicks DMP"
        description="Buchen Sie jetzt Ihr kostenloses Beratungsgespräch für professionelle Fotografie, Videoproduktion und Social Media Content in Mannheim & Rhein-Neckar."
        canonical="https://clicksdmp.com/termin"
        schema={<BreadcrumbSchema items={[{ name: "Startseite", url: "https://clicksdmp.com/" }, { name: "Termin buchen", url: "https://clicksdmp.com/termin" }]} />}
      />

      <div className="min-h-screen flex flex-col">
        <Header />
        
        <main className="flex-grow pt-32 pb-16">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-primary via-primary/80 to-primary bg-clip-text text-transparent">
                Termin buchen
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto">
                Vereinbaren Sie jetzt Ihr kostenloses Beratungsgespräch und lassen Sie uns gemeinsam Ihre Vision zum Leben erwecken.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                <div className="flex flex-col items-center p-6 rounded-xl bg-card border border-border hover:border-primary/50 transition-all">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                    <Calendar className="w-6 h-6 text-primary" />
                  </div>
                  <h2 className="font-semibold mb-2">Flexibel</h2>
                  <p className="text-sm text-muted-foreground">
                    Wählen Sie Ihren Wunschtermin
                  </p>
                </div>

                <div className="flex flex-col items-center p-6 rounded-xl bg-card border border-border hover:border-primary/50 transition-all">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                    <Clock className="w-6 h-6 text-primary" />
                  </div>
                  <h2 className="font-semibold mb-2">Schnell</h2>
                  <p className="text-sm text-muted-foreground">
                    Antwort innerhalb von 24h
                  </p>
                </div>

                <div className="flex flex-col items-center p-6 rounded-xl bg-card border border-border hover:border-primary/50 transition-all">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                    <MessageSquare className="w-6 h-6 text-primary" />
                  </div>
                  <h2 className="font-semibold mb-2">Unverbindlich</h2>
                  <p className="text-sm text-muted-foreground">
                    Kostenlose Erstberatung
                  </p>
                </div>

                <div className="flex flex-col items-center p-6 rounded-xl bg-card border border-border hover:border-primary/50 transition-all">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                    <CheckCircle2 className="w-6 h-6 text-primary" />
                  </div>
                  <h2 className="font-semibold mb-2">Professionell</h2>
                  <p className="text-sm text-muted-foreground">
                    Individuelle Beratung
                  </p>
                </div>
              </div>

              <div className="bg-muted/30 rounded-2xl p-8 md:p-12">
                <h2 className="text-2xl md:text-3xl font-bold mb-4">
                  Starten Sie jetzt Ihr Projekt
                </h2>
                <p className="text-muted-foreground mb-8 max-w-xl mx-auto">
                  Füllen Sie das Formular aus und wir melden uns zeitnah bei Ihnen, um alle Details zu besprechen.
                </p>
                <button
                  onClick={() => setShowBooking(true)}
                  className="border-primary/30 bg-primary/5 text-primary backdrop-blur-xs hover:bg-primary/10 px-8 py-4 text-lg rounded-full font-semibold transition-all border inline-flex items-center justify-center gap-2"
                >
                  <Calendar className="w-5 h-5" />
                  Buchungsformular öffnen
                </button>
              </div>

              <div className="mt-12 text-sm text-muted-foreground">
                <p>Alternativ erreichen Sie uns auch telefonisch unter:</p>
                <a 
                  href="tel:+4917670027200"
                  onClick={() => trackPhoneClick()}
                  className="text-primary hover:underline font-semibold text-lg mt-2 inline-block"
                >
                  +49 176 700 27 200
                </a>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>

      <BookingDialog open={showBooking} onOpenChange={setShowBooking} />
    </>
  );
};

export default Termin;
